import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-fim-adesao-seguro',
    templateUrl: './fim-adesao-seguro.component.html',
    styleUrls: ['./fim-adesao-seguro.component.css'],
    standalone: false
})
export class FimAdesaoSeguroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
